var Et = Object.defineProperty, At = Object.defineProperties;
var ft = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols, wt = Object.getPrototypeOf, q = Object.prototype.hasOwnProperty, V = Object.prototype.propertyIsEnumerable, Tt = Reflect.get;
var B = (r, t, e) => t in r ? Et(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, g = (r, t) => {
  for (var e in t || (t = {}))
    q.call(t, e) && B(r, e, t[e]);
  if ($)
    for (var e of $(t))
      V.call(t, e) && B(r, e, t[e]);
  return r;
}, y = (r, t) => At(r, ft(t));
var D = (r, t) => {
  var e = {};
  for (var s in r)
    q.call(r, s) && t.indexOf(s) < 0 && (e[s] = r[s]);
  if (r != null && $)
    for (var s of $(r))
      t.indexOf(s) < 0 && V.call(r, s) && (e[s] = r[s]);
  return e;
};
var P = (r, t, e) => Tt(wt(r), e, t);
var a = (r, t, e) => new Promise((s, i) => {
  var n = (c) => {
    try {
      p(e.next(c));
    } catch (h) {
      i(h);
    }
  }, o = (c) => {
    try {
      p(e.throw(c));
    } catch (h) {
      i(h);
    }
  }, p = (c) => c.done ? s(c.value) : Promise.resolve(c.value).then(n, o);
  p((e = e.apply(r, t)).next());
});
import { BaseResourceAPI as u, HttpResponseType as j, GraphUtils as Pt, RevertableArraySorter as bt, sleepPromise as at, HttpMethod as It, createRetryValidator as $t, BaseCogniteClient as Dt, accessApi as d, apiUrl as Ut } from "@cognite/sdk-core";
import { CogniteError as Mn, CogniteMultiError as jn, HttpError as On, HttpResponseType as _n } from "@cognite/sdk-core";
const Rt = "10.0.0";
class St extends u {
  constructor() {
    super(...arguments), this.list = (t, e, s) => {
      const i = this.encodeUrl(t, e);
      return super.listEndpoint(
        (n) => this.get(i, { params: n }),
        s
      );
    }, this.filter = (t, e, s) => {
      const i = `${this.encodeUrl(t, e)}/list`;
      return super.listEndpoint(
        (n) => this.post(i, { data: n }),
        s
      );
    }, this.create = (t, e, s) => {
      const i = this.encodeUrl(t, e);
      return super.createEndpoint(s, i);
    }, this.delete = (t, e, s) => {
      const i = `${this.encodeUrl(t, e)}/delete`;
      return super.deleteEndpoint(s, void 0, i);
    };
  }
  encodeUrl(t, e) {
    return this.url(`${t}/revisions/${e}/mappings`);
  }
}
class xt extends u {
  constructor() {
    super(...arguments), this.retrieve = (t) => a(this, null, function* () {
      const e = this.url(`${t}`), s = yield this.get(e, {
        responseType: j.ArrayBuffer
      });
      return this.addToMapAndReturn(s.data, s);
    });
  }
}
class Ft extends u {
  constructor() {
    super(...arguments), this.create = (t) => super.createEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (t) => a(this, null, function* () {
      const e = this.url(`${t}`), s = yield this.get(e);
      return this.addToMapAndReturn(s.data, s);
    }), this.update = (t) => super.updateEndpoint(t), this.delete = (t) => super.deleteEndpoint(t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime"]);
  }
}
class Mt extends u {
  constructor() {
    super(...arguments), this.retrieve = (t, e, s) => {
      const i = this.url(`${t}/revisions/${e}/nodes/byids`);
      return super.retrieveEndpoint(s, {}, i);
    };
  }
  list(t, e, s) {
    const i = this.url(`${t}/revisions/${e}/nodes`);
    return super.listEndpoint(
      (n) => this.get(i, { params: n }),
      s
    );
  }
  filter(t, e, s) {
    const i = this.url(`${t}/revisions/${e}/nodes/list`);
    return super.listEndpoint(
      (n) => this.post(i, { data: n }),
      s
    );
  }
  listAncestors(t, e, s, i) {
    const n = this.url(
      `${t}/revisions/${e}/nodes/${s}/ancestors`
    );
    return super.listEndpoint(
      (o) => this.get(n, { params: o }),
      i
    );
  }
}
class jt extends u {
  constructor(t, e, s) {
    super(t, e, s), this.create = (i, n) => super.createEndpoint(n, this.url(`${i}/revisions`)), this.list = (i, n) => {
      const o = this.url(`${i}/revisions`);
      return super.listEndpoint((p) => this.get(o, { params: p }), n);
    }, this.retrieve = (i, n) => a(this, null, function* () {
      const o = this.url(`${i}/revisions/${n}`), p = yield this.get(o);
      return this.addToMapAndReturn(p.data, p);
    }), this.update = (i, n) => {
      const o = this.url(`${i}/revisions/update`);
      return super.updateEndpoint(n, o);
    }, this.delete = (i, n) => {
      const o = this.url(`${i}/revisions/delete`);
      return super.deleteEndpoint(n, void 0, o);
    }, this.updateThumbnail = (i, n, o) => a(this, null, function* () {
      const p = this.url(`${i}/revisions/${n}/thumbnail`), c = yield this.post(p, { data: { fileId: o } });
      return this.addToMapAndReturn({}, c);
    }), this.list3DNodes = (i, n, o) => this.nodes3DApi.list(i, n, o), this.filter3DNodes = (i, n, o) => this.nodes3DApi.filter(i, n, o), this.retrieve3DNodes = (i, n, o) => this.nodes3DApi.retrieve(i, n, o), this.list3DNodeAncestors = (i, n, o, p) => this.nodes3DApi.listAncestors(i, n, o, p), this.nodes3DApi = new Mt(t, e, s);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime"]);
  }
}
class Ot extends u {
  list(t, e, s) {
    const i = this.encodeUrl(t, e);
    return super.listEndpoint((n) => this.get(i, { params: n }), s);
  }
  listAncestors(t, e, s, i) {
    const n = `${this.encodeUrl(t, e)}/${s}/ancestors`;
    return super.listEndpoint((o) => this.get(n, { params: o }), i);
  }
  encodeUrl(t, e) {
    return this.url(`models/${t}/revisions/${e}/nodes`);
  }
}
class _t extends u {
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime"]);
  }
  retrieve(t, e) {
    return a(this, null, function* () {
      const s = this.url(`models/${t}/revisions/${e}`), i = yield this.get(s);
      return this.addToMapAndReturn(i.data, i);
    });
  }
}
class Ct extends u {
  list(t, e, s) {
    const i = this.url(`models/${t}/revisions/${e}/sectors`);
    return super.listEndpoint((n) => this.get(i, { params: n }), s);
  }
}
class Lt extends u {
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime"]);
  }
  retrieve(t, e) {
    return a(this, null, function* () {
      const s = this.url(`models/${t}/revisions/${e}`), i = yield this.get(s);
      return this.addToMapAndReturn(i.data, i);
    });
  }
}
class Nt extends u {
  /** @hidden */
  constructor(t, e, s) {
    super(t, e, s), this.retrieveRevealRevision3D = (o, p) => this.revealRevisions3DAPI.retrieve(o, p), this.listRevealNodes3D = (o, p, c) => this.revealNodes3DAPI.list(o, p, c), this.listRevealNode3DAncestors = (o, p, c, h) => this.revealNodes3DAPI.listAncestors(
      o,
      p,
      c,
      h
    ), this.listRevealSectors3D = (o, p, c) => this.revealSectors3DAPI.list(o, p, c), this.retrieveUnrealRevision3D = (o, p) => this.unrealRevisions3DAPI.retrieve(o, p);
    const i = `${t}/reveal`, n = `${t}/unreal`;
    this.revealRevisions3DAPI = new _t(
      i,
      e,
      s
    ), this.revealNodes3DAPI = new Ot(i, e, s), this.revealSectors3DAPI = new Ct(
      i,
      e,
      s
    ), this.unrealRevisions3DAPI = new Lt(
      n,
      e,
      s
    );
  }
}
class kt extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.suggest = (t) => this.createEndpoint(t, this.suggestUrl), this.retrieve = (t) => this.retrieveEndpoint(t), this.list = (t) => this.listEndpoint(this.callListEndpointWithPost, t), this.delete = (t) => this.deleteEndpoint(t), this.update = (t) => this.updateEndpoint(t), this.reverseLookup = (t) => {
      const e = this.url("reverselookup");
      return this.cursorBasedEndpoint(
        (s) => this.post(e, {
          data: s
        }),
        t
      );
    };
  }
  /**
   * Specify that dates should be parsed in requests and responses
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
  get suggestUrl() {
    return this.url("suggest");
  }
}
function Gt(r) {
  const t = /* @__PURE__ */ new Map(), e = r.map((s) => ({
    data: s
  }));
  for (const s of e) {
    const { externalId: i } = s.data;
    i && t.set(i, s);
  }
  for (const s of e) {
    const { parentExternalId: i } = s.data;
    i && t.has(i) && (s.parentNode = t.get(i));
  }
  return e;
}
function Wt(r) {
  const t = Gt(r);
  return Pt.topologicalSort(t).map((s) => s.data);
}
class Bt extends u {
  constructor() {
    super(...arguments), this.create = (t) => {
      const { sort: e, unsort: s } = new bt(Wt);
      return super.createEndpoint(t, void 0, e, s);
    }, this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.aggregate = (t) => super.aggregateEndpoint(t), this.retrieve = (t, e = {}) => super.retrieveEndpoint(t, e), this.update = (t) => super.updateEndpoint(t), this.search = (t) => super.searchEndpoint(t), this.delete = (t, e = {}) => {
      const s = y(g({}, e), {
        ignoreUnknownIds: !0
      });
      return super.deleteEndpoint(t, s);
    };
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
}
class qt extends u {
  constructor() {
    super(...arguments), this.upsert = (t) => a(this, null, function* () {
      return (yield this.post(this.url(), {
        data: { items: t }
      })).data;
    }), this.delete = (t) => a(this, null, function* () {
      return (yield this.post(
        this.deleteUrl,
        {
          data: { items: t }
        }
      )).data;
    }), this.list = (t = { includeGlobal: !1 }) => super.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (t) => a(this, null, function* () {
      return (yield this.post(
        this.byIdsUrl,
        {
          data: { items: t }
        }
      )).data;
    });
  }
}
class Vt extends u {
  constructor() {
    super(...arguments), this.insert = (t) => this.insertEndpoint(t), this.retrieve = (t) => this.retrieveDatapointsEndpoint(t), this.retrieveDatapointMonthlyAggregates = (t) => a(this, null, function* () {
      var i;
      const e = t.start, s = t.end;
      if (e && s) {
        const o = this.getMonthsBetweenDates(e, s).map((E) => {
          const m = y(g({}, t), {
            start: E.startDate,
            end: E.endDate,
            granularity: `${E.numberOfDays}d`
          });
          return this.retrieveDatapointsEndpoint(m);
        }), p = yield Promise.all(o), c = {}, h = {};
        for (const E of p)
          for (const m of E)
            h[m.id] || (h[m.id] = m), (i = m == null ? void 0 : m.datapoints) != null && i.length && (c[m.id] ? c[m.id].push(...m.datapoints) : c[m.id] = m.datapoints);
        const w = [];
        for (const E in h) {
          const m = h[E];
          E in c ? m.datapoints = c[E] : m.datapoints = [], w.push(m);
        }
        return w;
      }
      return this.retrieveDatapointsEndpoint(t);
    }), this.retrieveLatest = (t, e = {}) => this.retrieveLatestEndpoint(t, e), this.delete = (t) => this.deleteDatapointsEndpoint(t), this.getMonthsBetweenDates = (t, e) => {
      const s = [], i = new Date(t);
      for (; i <= new Date(e); ) {
        const n = new Date(
          Date.UTC(i.getFullYear(), i.getMonth(), 1, 0)
        ), o = new Date(
          Date.UTC(i.getFullYear(), i.getMonth() + 1, 1, 0)
        );
        s.push({
          startDate: n.getTime(),
          endDate: o.getTime(),
          numberOfDays: (o.getTime() - n.getTime()) / (24 * 3600 * 1e3)
        }), i.setMonth(i.getMonth() + 1);
      }
      return s;
    };
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(
      ["items", "datapoints"],
      ["timestamp"]
    );
  }
  insertEndpoint(t) {
    return a(this, null, function* () {
      const e = this.url();
      return yield this.postInParallelWithAutomaticChunking({ path: e, items: t }), {};
    });
  }
  retrieveDatapointsEndpoint(t) {
    return a(this, null, function* () {
      const e = this.listPostUrl, s = yield this.post(e, {
        data: t
      });
      return this.addToMapAndReturn(s.data.items, s);
    });
  }
  retrieveLatestEndpoint(t, e) {
    return a(this, null, function* () {
      const s = this.url("latest"), i = yield this.post(s, {
        data: g({ items: t }, e)
      });
      return this.addToMapAndReturn(i.data.items, i);
    });
  }
  deleteDatapointsEndpoint(t) {
    return a(this, null, function* () {
      return yield this.postInParallelWithAutomaticChunking({
        chunkSize: 1e4,
        items: t,
        path: this.deleteUrl
      }), {};
    });
  }
}
class Kt extends u {
  constructor() {
    super(...arguments), this.create = (t) => super.createEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.aggregate = (t) => super.aggregateEndpoint(t), this.retrieve = (t, e) => super.retrieveEndpoint(t, e), this.update = (t) => super.updateEndpoint(t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
}
class Ht extends u {
  constructor() {
    super(...arguments), this.count = (t) => this.aggregate(y(g({}, t), {
      aggregate: "count"
    })).then((e) => e[0].count), this.uniqueValues = (t) => this.aggregate(y(g({}, t), {
      aggregate: "uniqueValues"
    })), this.allUniqueValues = (t) => this.cursorBasedEndpoint(this.callAggregateCursorEndpointWithPost, y(g({}, t), {
      aggregate: "allUniqueValues"
    })), this.uniqueProperties = (t) => this.aggregate(y(g({}, t), {
      aggregate: "uniqueProperties"
    })), this.allUniqueProperties = (t) => this.cursorBasedEndpoint(this.callAggregateCursorEndpointWithPost, y(g({}, t), {
      aggregate: "allUniqueProperties"
    })), this.callAggregateCursorEndpointWithPost = (t) => a(this, null, function* () {
      return yield this.post(this.url(), {
        data: t
      });
    });
  }
  aggregate(t) {
    return a(this, null, function* () {
      const e = yield this.post(this.url(), {
        data: t
      });
      return this.addToMapAndReturn(e.data.items, e);
    });
  }
}
class Xt extends u {
  constructor() {
    super(...arguments), this.documentAsPdf = (t) => this.pdfPreviewEndpoint(t), this.documentAsImage = (t, e) => this.imagePreviewEndpoint(t, e), this.pdfTemporaryLink = (t) => this.pdfTemporaryLinkEndpoint(
      t
    ), this.pdfBuildPreviewURI = (t) => `${this.url()}${t.toString()}/preview/pdf`, this.imageBuildPreviewURI = (t, e = 1) => `${this.url()}${t.toString()}/preview/image/pages/${e.toString()}`, this.pdfBuildTemporaryLinkURI = (t) => `${this.url()}${t.toString()}/preview/pdf/temporarylink`;
  }
  pdfPreviewEndpoint(t) {
    return a(this, null, function* () {
      const e = this.pdfBuildPreviewURI(t);
      return (yield this.get(e, {
        responseType: j.ArrayBuffer,
        headers: {
          Accept: "application/pdf"
        }
      })).data;
    });
  }
  imagePreviewEndpoint(t, e = 1) {
    return a(this, null, function* () {
      const s = this.imageBuildPreviewURI(t, e);
      return (yield this.get(s, {
        responseType: j.ArrayBuffer,
        headers: {
          Accept: "image/png"
        }
      })).data;
    });
  }
  pdfTemporaryLinkEndpoint(t) {
    return a(this, null, function* () {
      const e = this.pdfBuildTemporaryLinkURI(t);
      return (yield this.get(e)).data;
    });
  }
}
class Jt extends u {
  constructor(...t) {
    super(...t), this.search = (n) => this.searchDocuments(n), this.list = (n) => this.listEndpoint(this.callListEndpointWithPost, n), this.content = (n) => this.documentContent(n);
    const [e, s, i] = t;
    this.previewAPI = new Xt(e, s, i), this.aggregateAPI = new Ht(
      `${e}/aggregate`,
      s,
      i
    );
  }
  get preview() {
    return this.previewAPI;
  }
  get aggregate() {
    return this.aggregateAPI;
  }
  searchDocuments(t) {
    return a(this, null, function* () {
      const e = yield this.post(this.searchUrl, {
        data: t
      });
      return this.addToMapAndReturn(e.data, e);
    });
  }
  documentContent(t) {
    return a(this, null, function* () {
      return (yield this.get(this.url(`${t}/content`), {
        headers: {
          accept: "text/plain"
        }
      })).data;
    });
  }
}
class k extends u {
  constructor() {
    super(...arguments), this.create = (t) => a(this, null, function* () {
      const e = this.url(), s = yield this.post(e, {
        data: t
      });
      return this.addToMapAndReturn(s.data, s);
    }), this.retrieve = (t) => super.retrieveEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.update = (t) => super.updateEndpoint(t), this.delete = (t) => a(this, null, function* () {
      return P(k.prototype, this, "deleteEndpoint").call(this, t);
    }), this.predict = (t) => a(this, null, function* () {
      const e = this.url("predict"), s = yield this.post(e, {
        data: t
      });
      return this.addToMapAndReturn(s.data, s);
    }), this.predictResult = (t) => a(this, null, function* () {
      const e = this.url(`jobs/${t}`), s = yield this.get(e);
      return this.addToMapAndReturn(s.data, s);
    }), this.refit = (t) => a(this, null, function* () {
      const e = this.url("refit"), s = yield this.post(e, {
        data: t
      });
      return this.addToMapAndReturn(s.data, s);
    });
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(
      ["items"],
      ["createdTime", "startTime", "statusTime"]
    );
  }
}
class Qt extends u {
  constructor() {
    super(...arguments), this.count = (t) => super.aggregateEndpoint(t), this.uniqueValues = (t) => super.aggregateEndpoint(y(g({}, t), {
      aggregate: "uniqueValues"
    }));
  }
}
class Yt extends u {
  constructor(...t) {
    super(...t), this.create = (e) => super.createEndpoint(e), this.list = (e) => {
      const o = e || {}, { sort: s = {} } = o, i = D(o, ["sort"]), n = g({ sort: this.convertSortObjectToArray(s) }, i);
      return super.listEndpoint(this.callListEndpointWithPost, n);
    }, this.retrieve = (e, s = {}) => super.retrieveEndpoint(e, s), this.update = (e) => super.updateEndpoint(e), this.search = (e) => super.searchEndpoint(e), this.delete = (e) => super.deleteEndpoint(e), this.aggregateAPI = new Qt(...t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
  /**
   * The aggregation API allows you to compute aggregated results on events like getting the count of all events
   * in a project or checking what are all the different types and subtypes of events in your project,
   * along with the count of events in each of those aggregations.
   * By specifying an additional filter, you can also aggregate only among events matching the specified filter.
   */
  get aggregate() {
    return this.aggregateAPI;
  }
  convertSortObjectToArray(t) {
    return Object.entries(t).map(
      ([e, s]) => `${e}:${s}`
    );
  }
}
class zt extends Error {
  constructor() {
    super("Upload has already finished");
  }
}
class Zt extends u {
  constructor(...t) {
    super(t[0], t[1], t[2]), [, , , this.multiPartFileUploadResponse] = t, this.uploadedUrls = this.multiPartFileUploadResponse.uploadUrls.map(
      (e) => !1
    ), this.finished = !1;
  }
  uploadPart(t, e) {
    return a(this, null, function* () {
      if (!(e != null))
        throw Error("you are uploading empty content");
      if (t < 0 || t >= this.multiPartFileUploadResponse.uploadUrls.length)
        throw Error(
          `part number is outside allowed range 0 to ${this.multiPartFileUploadResponse.uploadUrls.length - 1}`
        );
      if (this.canCompleteUpload()) {
        yield this.completeMultiPartUpload();
        return;
      }
      if (!this.alreadyUploadedPart(t)) {
        if (this.multiPartFileUploadResponse.uploadUrls[t] === null)
          throw Error("part number is not valid");
        if (e != null) {
          const i = yield this.put(
            this.multiPartFileUploadResponse.uploadUrls[t],
            {
              data: e
            }
          );
          return i.status === 200 || i.status === 201 ? (this.uploadedUrls[t] = !0, this.canCompleteUpload() && (yield this.completeMultiPartUpload()), { partNumber: t, status: i.status }) : { partNumber: t, status: i.status };
        }
      }
    });
  }
  alreadyUploadedPart(t) {
    return this.uploadedUrls[t];
  }
  canCompleteUpload() {
    return this.uploadedUrls.length !== 0 && this.getNotCompletedParts().length === 0;
  }
  completeMultiPartUpload() {
    return a(this, null, function* () {
      if (this.finished)
        throw new zt();
      if (!this.canCompleteUpload())
        return;
      const t = this.url("completemultipartupload"), e = {
        id: this.multiPartFileUploadResponse.id,
        uploadId: this.multiPartFileUploadResponse.uploadId
      };
      if ((yield this.post(t, {
        data: e
      })).status !== 200)
        throw Error("upload cannot be completed");
      this.finished = !0;
    });
  }
  getNotCompletedParts() {
    return this.uploadedUrls.reduce((t, e, s) => (e === !1 && t.push(s), t), []);
  }
  getMultiPartFileUploadId() {
    return this.multiPartFileUploadResponse.uploadId;
  }
  getFinished() {
    return this.finished;
  }
}
class te extends u {
  constructor(...t) {
    super(...t), this.limits = {
      minimumNumberOfParts: 1,
      maxNumberOfParts: 250
    }, this.upload = (e, s, i = !1, n = !1) => this.uploadEndpoint(
      e,
      s,
      i,
      n
    ), this.list = (e) => super.listEndpoint(this.callListEndpointWithPost, e), this.aggregate = (e) => super.aggregateEndpoint(e), this.retrieve = (e, s = {}) => super.retrieveEndpoint(e, s), this.update = (e) => super.updateEndpoint(e), this.search = (e) => super.searchEndpoint(e), this.delete = (e) => super.deleteEndpoint(e), this.getDownloadUrls = (e) => this.getDownloadUrlsEndpoint(e), [this._baseUrl, this._client, this._map] = t;
  }
  /**
   * Specify that dates should be parsed in requests and responses
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(
      ["items"],
      [
        "createdTime",
        "lastUpdatedTime",
        "sourceCreatedTime",
        "sourceModifiedTime",
        "uploadedTime"
      ]
    );
  }
  uploadEndpoint(t, e, s = !1, i = !1) {
    return a(this, null, function* () {
      if (!(e != null) && i)
        throw Error(
          "Don't set waitUntilAcknowledged to true when you are not uploading a file"
        );
      const o = { overwrite: s }, p = this.url(), c = yield this.post(p, {
        params: o,
        data: t
      }), h = c.data;
      if (e != null && (yield this.uploadFile(h.uploadUrl, e, t.mimeType)), i) {
        const w = yield this.waitUntilFileIsUploaded(h.id);
        return this.addToMapAndReturn(w, c);
      }
      return this.addToMapAndReturn(h, c);
    });
  }
  uploadFile(t, e, s) {
    const i = {
      "Content-Type": s || "application/octet-stream"
    };
    return this.put(t, {
      headers: i,
      data: e
    });
  }
  // TODO: refactor - similar to RetryableHttpClient.rawRequest
  waitUntilFileIsUploaded(t) {
    return a(this, null, function* () {
      let i = 0;
      do {
        const [n] = yield this.retrieve([{ id: t }]);
        if (n.uploaded)
          return n;
        i++, yield at(500);
      } while (i < 10);
      throw Error("File never marked as 'uploaded'");
    });
  }
  getDownloadUrlsEndpoint(t) {
    return a(this, null, function* () {
      const e = this.url("downloadlink"), s = yield this.post(e, { data: { items: t } });
      return this.addToMapAndReturn(s.data.items, s);
    });
  }
  /**
   * [Init a multipart file upload](https://api-docs.cognite.com/20230101/tag/Files/operation/initMultiPartUpload)
   *
   * ```js
   * // Each file part must be larger than 5 MiB, and smaller than 4000 MiB. The file part for the last uploadURL can be smaller than 5 MiB.
   * const numberOfParts = 5;
   * // automatic upload:
   * const multiPartUploadApi = await client.files.multipartUploadSession({name: 'examplefile.jpg', mimeType: 'image/jpeg'}, numberOfParts);
   * ```
   */
  multipartUploadSession(t, e, s = !1) {
    return a(this, null, function* () {
      const i = yield this.getMultipartUploadSession(
        t,
        e,
        s
      ), n = new Zt(
        this._baseUrl,
        this._client,
        this._map,
        i.data
      );
      return this.addToMapAndReturn(n, i);
    });
  }
  getMultipartUploadSession(t, e, s = !1) {
    return a(this, null, function* () {
      if (e < this.limits.minimumNumberOfParts || e > this.limits.maxNumberOfParts)
        throw Error(
          `parts must be in range ${this.limits.minimumNumberOfParts} <= parts <= ${this.limits.maxNumberOfParts}`
        );
      const i = this.url("initmultipartupload"), n = { overwrite: s, parts: e };
      return yield this.post(i, {
        params: n,
        data: t
      });
    });
  }
}
class ee extends u {
  constructor() {
    super(...arguments), this.compute = (t) => a(this, null, function* () {
      const e = this.url();
      return (yield this.post(e, {
        data: t
      })).data;
    });
  }
}
class se extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.retrieve = (t) => this.retrieveEndpoint(t), this.list = (t) => this.listEndpoint(this.callListEndpointWithGet, t), this.delete = (t) => this.deleteEndpoint(t);
  }
}
class re extends u {
  constructor() {
    super(...arguments), this.create = (t, e) => this.createEndpoint(
      e,
      this.url(`${t}/features`)
    ), this.retrieve = (t, e, s) => this.callEndpointWithMergeAndTransform(
      e,
      (i) => this.postInParallelWithAutomaticChunking({
        path: this.url(`${t}/features/byids`),
        items: i,
        params: s
      })
    ), this.update = (t, e) => this.updateEndpoint(
      e,
      this.url(`${t}/features/update`)
    ), this.delete = (t, e) => this.deleteEndpoint(
      e,
      {},
      this.url(`${t}/features/delete`)
    ), this.search = (t, e = {}) => this.searchEndpoint(
      e,
      this.url(`${t}/features/search`)
    ), this.searchStream = (t, e = {}) => this.callSearchEndpoint(
      e,
      this.url(`${t}/features/search-streaming`)
      // not using addToMapAndReturn in then as WeakMap does not accept primitive values as key and we've string as our response
    ).then((s) => s.data), this.aggregate = (t, e) => this.aggregateEndpoint(
      e,
      this.url(`${t}/features/aggregate`)
    ), this.list = (t, e = {}) => {
      const s = this.url(`${t}/features/list`);
      return this.listEndpoint(
        (i) => a(this, null, function* () {
          return this.post(s, { data: i });
        }),
        e
      );
    };
  }
}
class ie extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.retrieve = (t) => this.retrieveEndpoint(t), this.list = () => this.listEndpoint(this.callListEndpointWithPost), this.delete = (t, e = {}) => this.deleteEndpoint(t, e), this.update = (t) => this.updateEndpoint(t);
  }
}
class ne extends u {
  constructor(...t) {
    super(...t);
    const [, e, s] = t;
    this.computeAPI = new ee(this.url("compute"), e, s), this.crsAPI = new se(this.url("crs"), e, s), this.featureTypeAPI = new ie(
      this.url("featuretypes"),
      e,
      s
    ), this.featureAPI = new re(this.url("featuretypes"), e, s);
  }
  get compute() {
    return this.computeAPI;
  }
  get crs() {
    return this.crsAPI;
  }
  get feature() {
    return this.featureAPI;
  }
  get featureType() {
    return this.featureTypeAPI;
  }
}
class ae extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.list = (t) => a(this, null, function* () {
      const e = this.url(), s = yield this.get(e, {
        params: t
      });
      return this.addToMapAndReturn(s.data.items, s);
    }), this.delete = (t) => super.deleteEndpoint(t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["deletedTime"]);
  }
}
class G extends u {
  constructor() {
    super(...arguments), this.search = (t) => a(this, null, function* () {
      return (yield this.post(
        this.searchUrl,
        {
          data: t
        }
      )).data;
    }), this.list = (t) => a(this, null, function* () {
      return (yield this.post(
        this.listPostUrl,
        {
          data: t
        }
      )).data;
    }), this.retrieve = (t) => a(this, null, function* () {
      return (yield this.post(
        this.byIdsUrl,
        {
          data: t
        }
      )).data;
    }), this.upsert = (t) => a(this, null, function* () {
      return (yield this.post(
        this.url(),
        {
          data: t
        }
      )).data;
    }), this.delete = (t) => a(this, null, function* () {
      return P(G.prototype, this, "deleteEndpoint").call(this, t);
    }), this.aggregate = (t) => a(this, null, function* () {
      return (yield this.post(this.aggregateUrl, {
        data: t
      })).data;
    }), this.query = (t) => a(this, null, function* () {
      return (yield this.post(this.url("query"), {
        data: t
      })).data;
    }), this.sync = (t) => a(this, null, function* () {
      return (yield this.post(this.url("sync"), {
        data: t
      })).data;
    });
  }
}
class oe extends u {
  constructor() {
    super(...arguments), this.create = (t) => super.createEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.delete = (t) => super.deleteEndpoint(t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime"]);
  }
}
class ue extends u {
  constructor() {
    super(...arguments), this.upsert = (t) => a(this, null, function* () {
      return (yield this.post(this.url(), {
        data: { items: t }
      })).data;
    }), this.delete = (t) => a(this, null, function* () {
      return (yield this.post(this.deleteUrl, {
        data: { items: t }
      })).data;
    }), this.list = (t = { includeGlobal: !1 }) => super.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (s, ...i) => a(this, [s, ...i], function* (t, e = {}) {
      return (yield this.post(
        this.byIdsUrl,
        {
          data: { items: t },
          params: g({}, e)
        }
      )).data;
    });
  }
}
class pe extends u {
  constructor() {
    super(...arguments), this.retrieve = (t) => a(this, null, function* () {
      const e = this.encodeUrl(t), s = yield this.get(e);
      return this.addToMapAndReturn(s.data, s);
    });
  }
  encodeUrl(t) {
    return this.url(`projects/${encodeURIComponent(t)}`);
  }
}
class ce extends u {
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["lastUpdatedTime"]);
  }
  insert(t, e, s, i = !1) {
    return a(this, null, function* () {
      const n = `${this.encodeUrl(t, e)}/rows`;
      return yield this.postInParallelWithAutomaticChunking({
        path: n,
        items: s,
        chunkSize: 5e3,
        queryParams: { ensureParent: i }
      }), {};
    });
  }
  list(t, e, s = {}) {
    const h = s, { onlyRowKeys: i, columns: n } = h, p = D(h, ["onlyRowKeys", "columns"]);
    i && (p.columns = ","), n && (p.columns = n.join(","));
    const c = `${this.encodeUrl(t, e)}/rows`;
    return super.listEndpoint(
      (w) => a(this, null, function* () {
        return this.get(c, {
          params: w
        });
      }),
      p
    );
  }
  retrieve(t, e, s) {
    return a(this, null, function* () {
      const i = `${this.encodeUrl(
        t,
        e
      )}/rows/${encodeURIComponent(s)}`, n = yield this.get(i);
      return this.addToMapAndReturn(n.data, n);
    });
  }
  delete(t, e, s) {
    return a(this, null, function* () {
      const i = `${this.encodeUrl(t, e)}/rows/delete`;
      return yield this.postInParallelWithAutomaticChunking({ path: i, items: s }), {};
    });
  }
  encodeUrl(t, e) {
    return this.url(
      `${encodeURIComponent(t)}/tables/${encodeURIComponent(
        e
      )}`
    );
  }
}
class de extends u {
  create(t, e, s = !1) {
    return a(this, null, function* () {
      const i = `${this.encodeUrl(t)}/tables`, n = yield this.postInParallelWithAutomaticChunking({
        queryParams: { ensureParent: s },
        items: e,
        path: i
      });
      return this.mergeItemsFromItemsResponse(n);
    });
  }
  list(t, e) {
    const s = `${this.encodeUrl(t)}/tables`;
    return super.listEndpoint(
      (i) => a(this, null, function* () {
        return this.get(s, {
          params: i
        });
      }),
      e
    );
  }
  delete(t, e) {
    const s = `${this.encodeUrl(t)}/tables/delete`;
    return this.deleteEndpoint(e, {}, s);
  }
  encodeUrl(t) {
    return this.url(`${encodeURIComponent(t)}`);
  }
}
class he extends u {
  /** @hidden */
  constructor(t, e, s) {
    super(t, e, s), this.createDatabases = (i) => super.createEndpoint(i), this.listDatabases = (i) => super.listEndpoint(this.callListEndpointWithGet, i), this.deleteDatabases = (i, n) => super.deleteEndpoint(
      i,
      n
    ), this.createTables = (i, n, o = !1) => this.rawTablesApi.create(i, n, o), this.listTables = (i, n) => this.rawTablesApi.list(i, n), this.deleteTables = (i, n) => this.rawTablesApi.delete(i, n), this.insertRows = (i, n, o, p = !1) => this.rawRowsApi.insert(i, n, o, p), this.listRows = (i, n, o) => this.rawRowsApi.list(i, n, o), this.retrieveRow = (i, n, o) => this.rawRowsApi.retrieve(i, n, o), this.deleteRows = (i, n, o) => this.rawRowsApi.delete(i, n, o), this.rawTablesApi = new de(t, e, s), this.rawRowsApi = new ce(t, e, s);
  }
}
class le extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.retrieve = (t, e = {}) => super.retrieveEndpoint(t, e), this.delete = (t, e = {}) => super.deleteEndpoint(t, e);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
}
class ge extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.list = (t) => super.listEndpoint(this.callListEndpointWithGet, t), this.delete = (t) => super.deleteEndpoint(t);
  }
}
class me extends u {
  insert(t) {
    return a(this, null, function* () {
      return yield this.postInParallelWithAutomaticChunking({
        path: this.url(),
        items: t,
        chunkSize: 1e4
      }), {};
    });
  }
  retrieve(t) {
    return super.listEndpoint(
      (e) => this.post(this.listPostUrl, { data: e }).then(
        this.transformRetrieveResponse
      ),
      t
    );
  }
  delete(t) {
    return this.deleteEndpoint(t);
  }
  transformRetrieveResponse(t) {
    const { rows: e, nextCursor: s, columns: i } = t.data, n = e.map(({ rowNumber: o, values: p }) => ({
      columns: i,
      rowNumber: o,
      values: p
    }));
    return y(g({}, t), {
      data: {
        items: n,
        nextCursor: s
      }
    });
  }
}
class ye extends u {
  /** @hidden */
  constructor(t, e, s) {
    super(t, e, s), this.create = (i) => super.createEndpoint(i), this.list = (i) => super.listEndpoint(this.callListEndpointWithPost, i), this.aggregate = (i) => super.aggregateEndpoint(i), this.retrieve = (i, n = {}) => super.retrieveEndpoint(i, n), this.update = (i) => super.updateEndpoint(i), this.search = (i) => super.searchEndpoint(i), this.delete = (i) => super.deleteEndpoint(i), this.insertRows = (i) => this.sequenceRowsAPI.insert(i), this.retrieveRows = (i) => this.sequenceRowsAPI.retrieve(i), this.deleteRows = (i) => this.sequenceRowsAPI.delete(i), this.sequenceRowsAPI = new me(
      `${this.url()}data`,
      e,
      s
    );
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(
      ["items", "columns"],
      ["createdTime", "lastUpdatedTime"]
    );
  }
}
class ve extends u {
  constructor() {
    super(...arguments), this.create = (t) => a(this, null, function* () {
      return (yield this.post(
        this.url(),
        { data: { items: t } }
      )).data.items;
    }), this.list = (t) => {
      const i = t || {}, { filter: e } = i, s = D(i, ["filter"]);
      return this.listEndpoint(this.callListEndpointWithGet, g(g({}, s), e));
    }, this.retrieve = (t) => this.retrieveEndpoint(t);
  }
  /**
   * [Revoke access to a session](https://api-docs.cognite.com/20230101/tag/Sessions/operation/revokeSessions)
   *
   * ```js
   * client.sessions.revoke([{ id: 1 }])
   * ```
   */
  revoke(t) {
    return a(this, null, function* () {
      const e = this.url("revoke");
      return (yield this.post(e, {
        data: { items: t }
      })).data.items;
    });
  }
}
class Ee extends u {
  constructor() {
    super(...arguments), this.upsert = (t) => a(this, null, function* () {
      return (yield this.post(
        this.url(),
        {
          data: { items: t }
        }
      )).data;
    }), this.delete = (t) => a(this, null, function* () {
      return (yield this.post(this.deleteUrl, {
        data: { items: t.map((s) => ({ space: s })) }
      })).data;
    }), this.list = (t = { includeGlobal: !1 }) => super.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (t) => a(this, null, function* () {
      return (yield this.post(
        this.byIdsUrl,
        {
          data: { items: t.map((s) => ({ space: s })) }
        }
      )).data;
    });
  }
}
class Ae extends u {
  constructor() {
    super(...arguments), this.runQuery = (i) => a(this, [i], function* ({
      query: t,
      variables: e,
      operationName: s
    }) {
      return (yield this.post(this.url(), {
        data: {
          query: t,
          variables: e,
          operationName: s
        }
      })).data;
    });
  }
}
class fe extends u {
  constructor() {
    super(...arguments), this.upsert = (t) => this.post(this.url("upsert"), {
      data: t
    }).then((e) => e.data), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.delete = (t) => this.post(this.url("delete"), {
      data: {
        version: t
      }
    });
  }
}
class we extends u {
  constructor() {
    super(...arguments), this.create = (t) => super.createEndpoint(t), this.upsert = (t) => super.createEndpoint(t, this.url("upsert")), this.retrieve = (t, e) => super.retrieveEndpoint(t, e || { ignoreUnknownIds: !1 }), this.list = (t) => super.listEndpoint(this.callListEndpointWithPost, t), this.delete = (t, e) => super.deleteEndpoint(
      t,
      e || {
        ignoreUnknownIds: !1
      }
    );
  }
}
var U = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ot(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Te(r) {
  for (var t = -1, e = r == null ? 0 : r.length, s = {}; ++t < e; ) {
    var i = r[t];
    s[i[0]] = i[1];
  }
  return s;
}
var Pe = Te;
const K = /* @__PURE__ */ ot(Pe);
function be(r, t) {
  for (var e = -1, s = r == null ? 0 : r.length, i = Array(s); ++e < s; )
    i[e] = t(r[e], e, r);
  return i;
}
var Ie = be, $e = Ie;
function De(r, t) {
  return $e(t, function(e) {
    return [e, r[e]];
  });
}
var Ue = De, Re = typeof U == "object" && U && U.Object === Object && U, ut = Re, Se = ut, xe = typeof self == "object" && self && self.Object === Object && self, Fe = Se || xe || Function("return this")(), A = Fe, Me = A, je = Me.Symbol, pt = je, H = pt, ct = Object.prototype, Oe = ct.hasOwnProperty, _e = ct.toString, b = H ? H.toStringTag : void 0;
function Ce(r) {
  var t = Oe.call(r, b), e = r[b];
  try {
    r[b] = void 0;
    var s = !0;
  } catch (n) {
  }
  var i = _e.call(r);
  return s && (t ? r[b] = e : delete r[b]), i;
}
var Le = Ce, Ne = Object.prototype, ke = Ne.toString;
function Ge(r) {
  return ke.call(r);
}
var We = Ge, X = pt, Be = Le, qe = We, Ve = "[object Null]", Ke = "[object Undefined]", J = X ? X.toStringTag : void 0;
function He(r) {
  return r == null ? r === void 0 ? Ke : Ve : J && J in Object(r) ? Be(r) : qe(r);
}
var F = He;
function Xe(r) {
  var t = typeof r;
  return r != null && (t == "object" || t == "function");
}
var dt = Xe, Je = F, Qe = dt, Ye = "[object AsyncFunction]", ze = "[object Function]", Ze = "[object GeneratorFunction]", ts = "[object Proxy]";
function es(r) {
  if (!Qe(r))
    return !1;
  var t = Je(r);
  return t == ze || t == Ze || t == Ye || t == ts;
}
var ht = es, ss = A, rs = ss["__core-js_shared__"], is = rs, M = is, Q = function() {
  var r = /[^.]+$/.exec(M && M.keys && M.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function ns(r) {
  return !!Q && Q in r;
}
var as = ns, os = Function.prototype, us = os.toString;
function ps(r) {
  if (r != null) {
    try {
      return us.call(r);
    } catch (t) {
    }
    try {
      return r + "";
    } catch (t) {
    }
  }
  return "";
}
var lt = ps, cs = ht, ds = as, hs = dt, ls = lt, gs = /[\\^$.*+?()[\]{}|]/g, ms = /^\[object .+?Constructor\]$/, ys = Function.prototype, vs = Object.prototype, Es = ys.toString, As = vs.hasOwnProperty, fs = RegExp(
  "^" + Es.call(As).replace(gs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ws(r) {
  if (!hs(r) || ds(r))
    return !1;
  var t = cs(r) ? fs : ms;
  return t.test(ls(r));
}
var Ts = ws;
function Ps(r, t) {
  return r == null ? void 0 : r[t];
}
var bs = Ps, Is = Ts, $s = bs;
function Ds(r, t) {
  var e = $s(r, t);
  return Is(e) ? e : void 0;
}
var I = Ds, Us = I, Rs = A, Ss = Us(Rs, "DataView"), xs = Ss, Fs = I, Ms = A, js = Fs(Ms, "Map"), Os = js, _s = I, Cs = A, Ls = _s(Cs, "Promise"), Ns = Ls, ks = I, Gs = A, Ws = ks(Gs, "Set"), Bs = Ws, qs = I, Vs = A, Ks = qs(Vs, "WeakMap"), Hs = Ks, O = xs, _ = Os, C = Ns, L = Bs, N = Hs, gt = F, T = lt, Y = "[object Map]", Xs = "[object Object]", z = "[object Promise]", Z = "[object Set]", tt = "[object WeakMap]", et = "[object DataView]", Js = T(O), Qs = T(_), Ys = T(C), zs = T(L), Zs = T(N), f = gt;
(O && f(new O(new ArrayBuffer(1))) != et || _ && f(new _()) != Y || C && f(C.resolve()) != z || L && f(new L()) != Z || N && f(new N()) != tt) && (f = function(r) {
  var t = gt(r), e = t == Xs ? r.constructor : void 0, s = e ? T(e) : "";
  if (s)
    switch (s) {
      case Js:
        return et;
      case Qs:
        return Y;
      case Ys:
        return z;
      case zs:
        return Z;
      case Zs:
        return tt;
    }
  return t;
});
var tr = f;
function er(r) {
  var t = -1, e = Array(r.size);
  return r.forEach(function(s, i) {
    e[++t] = [i, s];
  }), e;
}
var sr = er;
function rr(r) {
  var t = -1, e = Array(r.size);
  return r.forEach(function(s) {
    e[++t] = [s, s];
  }), e;
}
var ir = rr, nr = Ue, ar = tr, or = sr, ur = ir, pr = "[object Map]", cr = "[object Set]";
function dr(r) {
  return function(t) {
    var e = ar(t);
    return e == pr ? or(t) : e == cr ? ur(t) : nr(t, r(t));
  };
}
var hr = dr;
function lr(r, t) {
  for (var e = -1, s = Array(r); ++e < r; )
    s[e] = t(e);
  return s;
}
var gr = lr;
function mr(r) {
  return r != null && typeof r == "object";
}
var W = mr, yr = F, vr = W, Er = "[object Arguments]";
function Ar(r) {
  return vr(r) && yr(r) == Er;
}
var fr = Ar, st = fr, wr = W, mt = Object.prototype, Tr = mt.hasOwnProperty, Pr = mt.propertyIsEnumerable, br = st(/* @__PURE__ */ function() {
  return arguments;
}()) ? st : function(r) {
  return wr(r) && Tr.call(r, "callee") && !Pr.call(r, "callee");
}, Ir = br, $r = Array.isArray, Dr = $r, R = { exports: {} };
function Ur() {
  return !1;
}
var Rr = Ur;
R.exports;
(function(r, t) {
  var e = A, s = Rr, i = t && !t.nodeType && t, n = i && !0 && r && !r.nodeType && r, o = n && n.exports === i, p = o ? e.Buffer : void 0, c = p ? p.isBuffer : void 0, h = c || s;
  r.exports = h;
})(R, R.exports);
var Sr = R.exports, xr = 9007199254740991, Fr = /^(?:0|[1-9]\d*)$/;
function Mr(r, t) {
  var e = typeof r;
  return t = t == null ? xr : t, !!t && (e == "number" || e != "symbol" && Fr.test(r)) && r > -1 && r % 1 == 0 && r < t;
}
var jr = Mr, Or = 9007199254740991;
function _r(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= Or;
}
var yt = _r, Cr = F, Lr = yt, Nr = W, kr = "[object Arguments]", Gr = "[object Array]", Wr = "[object Boolean]", Br = "[object Date]", qr = "[object Error]", Vr = "[object Function]", Kr = "[object Map]", Hr = "[object Number]", Xr = "[object Object]", Jr = "[object RegExp]", Qr = "[object Set]", Yr = "[object String]", zr = "[object WeakMap]", Zr = "[object ArrayBuffer]", ti = "[object DataView]", ei = "[object Float32Array]", si = "[object Float64Array]", ri = "[object Int8Array]", ii = "[object Int16Array]", ni = "[object Int32Array]", ai = "[object Uint8Array]", oi = "[object Uint8ClampedArray]", ui = "[object Uint16Array]", pi = "[object Uint32Array]", l = {};
l[ei] = l[si] = l[ri] = l[ii] = l[ni] = l[ai] = l[oi] = l[ui] = l[pi] = !0;
l[kr] = l[Gr] = l[Zr] = l[Wr] = l[ti] = l[Br] = l[qr] = l[Vr] = l[Kr] = l[Hr] = l[Xr] = l[Jr] = l[Qr] = l[Yr] = l[zr] = !1;
function ci(r) {
  return Nr(r) && Lr(r.length) && !!l[Cr(r)];
}
var di = ci;
function hi(r) {
  return function(t) {
    return r(t);
  };
}
var li = hi, S = { exports: {} };
S.exports;
(function(r, t) {
  var e = ut, s = t && !t.nodeType && t, i = s && !0 && r && !r.nodeType && r, n = i && i.exports === s, o = n && e.process, p = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch (h) {
    }
  }();
  r.exports = p;
})(S, S.exports);
var gi = S.exports, mi = di, yi = li, rt = gi, it = rt && rt.isTypedArray, vi = it ? yi(it) : mi, Ei = vi, Ai = gr, fi = Ir, wi = Dr, Ti = Sr, Pi = jr, bi = Ei, Ii = Object.prototype, $i = Ii.hasOwnProperty;
function Di(r, t) {
  var e = wi(r), s = !e && fi(r), i = !e && !s && Ti(r), n = !e && !s && !i && bi(r), o = e || s || i || n, p = o ? Ai(r.length, String) : [], c = p.length;
  for (var h in r)
    (t || $i.call(r, h)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (h == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (h == "offset" || h == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (h == "buffer" || h == "byteLength" || h == "byteOffset") || // Skip index properties.
    Pi(h, c))) && p.push(h);
  return p;
}
var Ui = Di, Ri = Object.prototype;
function Si(r) {
  var t = r && r.constructor, e = typeof t == "function" && t.prototype || Ri;
  return r === e;
}
var xi = Si;
function Fi(r, t) {
  return function(e) {
    return r(t(e));
  };
}
var Mi = Fi, ji = Mi, Oi = ji(Object.keys, Object), _i = Oi, Ci = xi, Li = _i, Ni = Object.prototype, ki = Ni.hasOwnProperty;
function Gi(r) {
  if (!Ci(r))
    return Li(r);
  var t = [];
  for (var e in Object(r))
    ki.call(r, e) && e != "constructor" && t.push(e);
  return t;
}
var Wi = Gi, Bi = ht, qi = yt;
function Vi(r) {
  return r != null && qi(r.length) && !Bi(r);
}
var Ki = Vi, Hi = Ui, Xi = Wi, Ji = Ki;
function Qi(r) {
  return Ji(r) ? Hi(r) : Xi(r);
}
var Yi = Qi, zi = hr, Zi = Yi, tn = zi(Zi), en = tn;
const nt = /* @__PURE__ */ ot(en), Pn = {
  READY: "READY",
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
  ACCESS_LOST: "ACCESS_LOST"
}, bn = {
  CLIENT_CREDENTIALS: "CLIENT_CREDENTIALS",
  TOKEN_EXCHANGE: "TOKEN_EXCHANGE",
  ONESHOT_TOKEN_EXCHANGE: "ONESHOT_TOKEN_EXCHANGE"
};
function sn(r) {
  return r.members !== void 0;
}
function In(r) {
  return !sn(r);
}
const $n = {
  STRING: "STRING",
  DOUBLE: "DOUBLE",
  LONG: "LONG"
}, Dn = {
  ASC: "asc",
  DESC: "desc"
}, Un = {
  QUEUED: "QUEUED",
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}, Rn = {
  SIMPLE: "simple",
  BIGRAM: "bigram",
  FREQUENCY_WEIGHTED_BIGRAM: "frequencyweightedbigram",
  BIGRAM_EXTRA_TOKENIZERS: "bigramextratokenizers",
  BIGRAM_COMBO: "bigramcombo"
}, Sn = {
  RANDOM_FOREST: "randomforest",
  DECISION_TREE: "decisiontree",
  LOGISTIC_REGRESSION: "logisticregression",
  AUGMENTED_LOGISTIC_REGRESSION: "augmentedlogisticregression",
  AUGMENTED_RANDOM_FOREST: "augmentedrandomforest"
};
var rn = /* @__PURE__ */ ((r) => (r.Patch = "Patch", r.Update = "Update", r.Force = "Force", r))(rn || {});
class nn {
  constructor(t) {
    this.type = "constant", this.value = t;
  }
}
class an {
  constructor(t, e, s, i) {
    this.type = "raw", this.dbName = t, this.tableName = e, this.rowKey = s, this.columnName = i;
  }
}
class on {
  constructor(t, e, s, i, n, o, p) {
    this.type = "syntheticTimeSeries", this.expression = t, this.name = e, this.metadata = s, this.description = i, this.isStep = n, this.isString = o, this.unit = p;
  }
}
class un {
  constructor(t, e) {
    this.type = "view", this.externalId = t, this.input = e;
  }
}
class pn extends u {
  constructor() {
    super(...arguments), this.create = (t) => super.createEndpoint(v.encodeTemplateInstances(t)).then(v.decodeTemplateInstances), this.upsert = (t) => super.createEndpoint(
      v.encodeTemplateInstances(t),
      this.url("upsert")
    ).then(v.decodeTemplateInstances), this.update = (t) => super.updateEndpoint(t.map(v.encodePatch)).then(v.decodeTemplateInstances), this.retrieve = (t, e) => super.retrieveEndpoint(t, e || { ignoreUnknownIds: !1 }).then(v.decodeTemplateInstances), this.list = (t) => super.listEndpoint((e) => a(this, null, function* () {
      const s = yield this.callListEndpointWithPost(e);
      return y(g({}, s), {
        data: y(g({}, s.data), {
          items: v.decodeTemplateInstances(s.data.items)
        })
      });
    }), t), this.delete = (t, e) => super.deleteEndpoint(
      t,
      e || {
        ignoreUnknownIds: !1
      }
    );
  }
}
class v {
  static encodeTemplateInstances(t) {
    return t.map((e) => y(g({}, e), {
      fieldResolvers: v.encodeFieldResolvers(
        e.fieldResolvers
      )
    }));
  }
  static encodePatch(t) {
    return y(g({}, t), {
      update: {
        fieldResolvers: {
          add: "add" in t.update.fieldResolvers ? v.encodeFieldResolvers(
            t.update.fieldResolvers.add
          ) : (
            // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
            void 0
          ),
          remove: "remove" in t.update.fieldResolvers ? t.update.fieldResolvers.remove : (
            // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
            void 0
          ),
          set: "set" in t.update.fieldResolvers ? v.encodeFieldResolvers(
            t.update.fieldResolvers.set
          ) : (
            // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
            void 0
          )
        }
      }
    });
  }
  static encodeFieldResolvers(t) {
    const e = nt(t).map(
      ([s, i]) => i !== void 0 && !v.isFieldResolver(i) ? [s, new nn(i)] : [s, i]
    );
    return K(e);
  }
  static decodeTemplateInstances(t) {
    return t.map((e) => y(g({}, e), {
      fieldResolvers: v.decodeFieldResolvers(
        e.fieldResolvers
      )
    }));
  }
  static decodeFieldResolvers(t) {
    const e = nt(t).map(
      ([s, i]) => [
        s,
        // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
        v.decodeFieldResolver(i)
      ]
    );
    return K(e);
  }
  // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
  static decodeFieldResolver(t) {
    switch (t.type) {
      case "constant":
        return t.value;
      case "raw":
        return new an(
          t.dbName,
          t.tableName,
          t.rowKey,
          t.columnName
        );
      case "syntheticTimeSeries":
        return new on(
          t.expression,
          t.name,
          t.metadata,
          t.description,
          t.isStep,
          t.isString,
          t.unit
        );
      case "view":
        return new un(t.externalId, t.input);
      default:
        throw new Error("Unknown field resolver type");
    }
  }
  // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
  static isFieldResolver(t) {
    return t.type === "constant" || t.type === "raw" || t.type === "syntheticTimeSeries" || t.type === "view";
  }
}
class cn extends u {
  constructor() {
    super(...arguments), this.create = (t) => this.createEndpoint(t), this.upsert = (t) => this.createEndpoint(t, this.url("upsert")), this.list = (t) => this.listEndpoint(this.callListEndpointWithPost, t), this.resolve = (t) => {
      const e = (s) => a(this, null, function* () {
        return yield this.post(
          this.url("resolve"),
          {
            data: s || {}
          }
        );
      });
      return this.listEndpoint(
        // biome-ignore lint/suspicious/noExplicitAny: didn't manage to type this properly within reasonable time
        e,
        t
      );
    }, this.delete = (t, e) => super.deleteEndpoint(
      t,
      e || {
        ignoreUnknownIds: !1
      }
    );
  }
}
class dn extends u {
  constructor() {
    super(...arguments), this.query = (t) => this.querySyntheticEndpoint(t);
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(
      ["items", "datapoints"],
      ["timestamp"]
    );
  }
  querySyntheticEndpoint(t) {
    return a(this, null, function* () {
      const e = this.url("query");
      return this.callEndpointWithMergeAndTransform(
        t,
        (s) => this.postInParallelWithAutomaticChunking({
          path: e,
          items: s,
          chunkSize: 10
        })
      );
    });
  }
}
class hn extends u {
  /** @hidden */
  constructor(t, ...e) {
    super(t, ...e), this.create = (s) => super.createEndpoint(s), this.list = (s) => super.listEndpoint(this.callListEndpointWithPost, s), this.aggregate = (s) => super.aggregateEndpoint(s), this.retrieve = (s, i = {}) => super.retrieveEndpoint(s, i), this.update = (s) => super.updateEndpoint(s), this.search = (s) => super.searchEndpoint(s), this.delete = (s) => super.deleteEndpoint(s), this.syntheticQuery = (s) => this.syntheticTimeseriesApi.query(s), this.syntheticTimeseriesApi = new dn(
      this.url("synthetic"),
      ...e
    );
  }
  /**
   * @hidden
   */
  getDateProps() {
    return this.pickDateProps(["items"], ["createdTime", "lastUpdatedTime"]);
  }
}
class ln extends u {
  constructor() {
    super(...arguments), this.list = () => a(this, null, function* () {
      return this.listEndpoint(this.callListEndpointWithGet);
    });
  }
}
class gn extends u {
  constructor(...t) {
    super(...t), this.list = () => a(this, null, function* () {
      return this.listEndpoint(this.callListEndpointWithGet);
    }), this.retrieve = (n) => a(this, null, function* () {
      return this.retrieveEndpoint(n);
    }), this.listUnitSystems = () => a(this, null, function* () {
      return this.unitSystemsApi.list();
    });
    const [e, s, i] = t;
    this.unitSystemsApi = new ln(
      `${e}/systems`,
      s,
      i
    );
  }
}
class x extends u {
  constructor() {
    super(...arguments), this.me = () => a(this, null, function* () {
      const t = this.url("me"), e = yield this.get(t);
      return this.addToMapAndReturn(e.data, e);
    }), this.list = (t) => this.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (t) => a(this, null, function* () {
      return P(x.prototype, this, "retrieveEndpoint").call(this, t);
    }), this.search = (t) => a(this, null, function* () {
      return P(x.prototype, this, "searchEndpoint").call(this, t);
    });
  }
}
class mn extends u {
  constructor() {
    super(...arguments), this.upsert = (t) => a(this, null, function* () {
      return (yield this.post(this.url(), {
        data: { items: t }
      })).data;
    }), this.delete = (t) => a(this, null, function* () {
      return (yield this.post(this.deleteUrl, {
        data: { items: t }
      })).data;
    }), this.list = (t = { includeGlobal: !1 }) => super.listEndpoint(this.callListEndpointWithGet, t), this.retrieve = (s, ...i) => a(this, [s, ...i], function* (t, e = {}) {
      return (yield this.post(this.byIdsUrl, {
        data: g({ items: t }, e)
      })).data;
    });
  }
}
const yn = ["Completed", "Failed"], vn = [
  "IndustrialObjectDetection",
  "PersonalProtectiveEquipmentDetection"
];
class En extends u {
  constructor() {
    super(...arguments), this.extract = (t, e, s) => a(this, null, function* () {
      const i = this.url("extract");
      let n = {};
      const o = t.filter((c) => vn.includes(c));
      o.length > 0 && (console.warn(
        `Features '${o}' are in beta and are still in development`
      ), n = y(g({}, n), { "cdf-version": "beta" }));
      const p = yield this.post(i, {
        data: { features: t, items: e, parameters: s },
        headers: n
      });
      return this.addToMapAndReturn(p.data, p);
    }), this.getExtractJob = (t, e = !0, s = 1e3, i = 600) => a(this, null, function* () {
      const n = this.url(`extract/${t}`), o = () => a(this, null, function* () {
        const c = yield this.get(n);
        return this.addToMapAndReturn(c.data, c);
      }), p = (c) => yn.includes(c.status);
      return e ? this.waitForJobToCompleteAndReturn(
        o,
        p,
        s,
        i
      ) : o();
    });
  }
  waitForJobToCompleteAndReturn(t, e, s, i) {
    return a(this, null, function* () {
      let n = 0;
      do {
        const o = yield t();
        if (e(o)) return o;
        yield at(s), n++;
      } while (n < i);
      throw new Error("Timed out while waiting for vision job to complete.");
    });
  }
}
const An = {
  [It.Post]: [
    "/assets/list",
    "/assets/byids",
    "/assets/search",
    "/events/list",
    "/events/byids",
    "/events/search",
    "/files/list",
    "/files/byids",
    "/files/search",
    "/files/initupload",
    "/files/downloadlink",
    "/timeseries/byids",
    "/timeseries/search",
    "/timeseries/data",
    "/timeseries/data/list",
    "/timeseries/data/latest",
    "/timeseries/data/delete",
    "/timeseries/synthetic/query"
  ]
}, fn = $t(An);
class vt extends Dt {
  get assets() {
    return d(this.assetsApi);
  }
  get timeseries() {
    return d(this.timeSeriesApi);
  }
  get datapoints() {
    return d(this.dataPointsApi);
  }
  get sequences() {
    return d(this.sequencesApi);
  }
  get events() {
    return d(this.eventsApi);
  }
  get files() {
    return d(this.filesApi);
  }
  get labels() {
    return d(this.labelsApi);
  }
  get raw() {
    return d(this.rawApi);
  }
  get projects() {
    return d(this.projectsApi);
  }
  get groups() {
    return d(this.groupsApi);
  }
  get securityCategories() {
    return d(this.securityCategoriesApi);
  }
  get models3D() {
    return d(this.models3DApi);
  }
  get revisions3D() {
    return d(this.revisions3DApi);
  }
  get files3D() {
    return d(this.files3DApi);
  }
  get datasets() {
    return d(this.datasetsApi);
  }
  get assetMappings3D() {
    return d(this.assetMappings3DApi);
  }
  get viewer3D() {
    return d(this.viewer3DApi);
  }
  get relationships() {
    return d(this.relationshipsApi);
  }
  get entityMatching() {
    return d(this.entityMatchingApi);
  }
  get geospatial() {
    return d(this.geospatialApi);
  }
  get documents() {
    return d(this.documentsApi);
  }
  get annotations() {
    return d(this.annotationsApi);
  }
  get vision() {
    return d(this.visionApi);
  }
  get profiles() {
    return d(this.profilesApi);
  }
  get sessions() {
    return d(this.sessionsApi);
  }
  get templates() {
    return {
      groups: d(this.apiFactory(we, "templategroups")),
      group: (t) => {
        const s = `templategroups/${vt.urlEncodeExternalId(t)}/versions`;
        return {
          versions: d(
            this.apiFactory(fe, s)
          ),
          version: (i) => {
            const n = `${s}/${i}`, o = this.apiFactory(
              Ae,
              `${n}/graphql`
            );
            return {
              instances: d(
                this.apiFactory(
                  pn,
                  `${n}/instances`
                )
              ),
              runQuery: (p) => a(this, null, function* () {
                return o.runQuery(p);
              }),
              views: d(
                this.apiFactory(cn, `${n}/views`)
              )
            };
          }
        };
      }
    };
  }
  get units() {
    return d(this.unitsApi);
  }
  get instances() {
    return d(this.instancesApi);
  }
  get containers() {
    return d(this.containersApi);
  }
  get views() {
    return d(this.viewsApi);
  }
  get spaces() {
    return d(this.spacesApi);
  }
  get dataModels() {
    return d(this.dataModelsApi);
  }
  get version() {
    return Rt;
  }
  getRetryValidator() {
    return fn;
  }
  initAPIs() {
    const t = "3d/models";
    this.httpClient.setDefaultHeader("cdf-version", "V20210406"), this.assetsApi = this.apiFactory(Bt, "assets"), this.timeSeriesApi = this.apiFactory(hn, "timeseries"), this.dataPointsApi = this.apiFactory(Vt, "timeseries/data"), this.sequencesApi = this.apiFactory(ye, "sequences"), this.eventsApi = this.apiFactory(Yt, "events"), this.filesApi = this.apiFactory(te, "files"), this.labelsApi = this.apiFactory(oe, "labels"), this.datasetsApi = this.apiFactory(Kt, "datasets"), this.rawApi = this.apiFactory(he, "raw/dbs"), this.groupsApi = this.apiFactory(ae, "groups"), this.securityCategoriesApi = this.apiFactory(
      ge,
      "securitycategories"
    ), this.models3DApi = this.apiFactory(Ft, t), this.relationshipsApi = this.apiFactory(le, "relationships"), this.entityMatchingApi = this.apiFactory(
      k,
      "context/entitymatching"
    ), this.revisions3DApi = this.apiFactory(jt, t), this.files3DApi = this.apiFactory(xt, "3d/files"), this.assetMappings3DApi = this.apiFactory(St, t), this.viewer3DApi = this.apiFactory(Nt, "3d"), this.projectsApi = new pe(
      Ut(),
      this.httpClient,
      this.metadataMap
    ), this.geospatialApi = this.apiFactory(ne, "geospatial"), this.documentsApi = this.apiFactory(Jt, "documents"), this.annotationsApi = this.apiFactory(kt, "annotations"), this.visionApi = this.apiFactory(En, "context/vision"), this.profilesApi = this.apiFactory(x, "profiles"), this.unitsApi = this.apiFactory(gn, "units"), this.instancesApi = this.apiFactory(G, "models/instances"), this.containersApi = this.apiFactory(qt, "models/containers"), this.viewsApi = this.apiFactory(mn, "models/views"), this.spacesApi = this.apiFactory(Ee, "models/spaces"), this.dataModelsApi = this.apiFactory(ue, "models/datamodels"), this.sessionsApi = this.apiFactory(ve, "sessions");
  }
  static urlEncodeExternalId(t) {
    return encodeURIComponent(t);
  }
}
export {
  St as AssetMappings3DAPI,
  Bt as AssetsAPI,
  vt as CogniteClient,
  Mn as CogniteError,
  jn as CogniteMultiError,
  rn as ConflictMode,
  nn as ConstantResolver,
  Un as ContextJobStatus,
  Vt as DataPointsAPI,
  Kt as DataSetsAPI,
  k as EntityMatchingApi,
  Sn as EntityMatchingClassifier,
  Rn as EntityMatchingFeatureType,
  Yt as EventsAPI,
  Qt as EventsAggregateAPI,
  xt as Files3DAPI,
  te as FilesAPI,
  Zt as FilesMultipartUploadSessionAPI,
  ae as GroupsAPI,
  On as HttpError,
  _n as HttpResponseType,
  oe as LabelsAPI,
  Ft as Models3DAPI,
  Mt as Nodes3DAPI,
  pe as ProjectsAPI,
  he as RawAPI,
  an as RawResolver,
  ce as RawRowsAPI,
  de as RawTablesAPI,
  le as RelationshipsApi,
  Ot as RevealNodes3DAPI,
  _t as RevealRevisions3DAPI,
  Ct as RevealSectors3DAPI,
  jt as Revisions3DAPI,
  ge as SecurityCategoriesAPI,
  me as SequenceRowsAPI,
  $n as SequenceValueType,
  ye as SequencesAPI,
  Pn as SessionStatus,
  bn as SessionType,
  Dn as SortOrder,
  dn as SyntheticTimeSeriesAPI,
  on as SyntheticTimeSeriesResolver,
  Ae as TemplateGraphQlApi,
  fe as TemplateGroupVersionsApi,
  we as TemplateGroupsApi,
  pn as TemplateInstancesApi,
  hn as TimeSeriesAPI,
  Lt as UnrealRevisions3DAPI,
  un as ViewResolver,
  Nt as Viewer3DAPI,
  cn as ViewsApi,
  In as isManagedExternallyGroup,
  sn as isManagedInCDFGroup
};
//# sourceMappingURL=index.js.map
